import { Action } from '../../../shared/xs/actions';

export class GetCommentsAction implements Action {
  static readonly type = '[Validation] Get Comments';
}
